import React from 'react';

import { Container, Row, Col } from '../../designSystem/Container';

import styles from './FullBanner.module.scss';

type FullBannerT = {
  theme?: 'light' | 'dark';
  children: JSX.Element | JSX.Element[];
};

const FullBanner = ({ theme = 'dark', children }: FullBannerT) => {
  return (
    <div className={`${styles.full_banner} ${styles[`full_banner_${theme}`]}`}>
      <Container className={styles.full_banner_container}>
        <Row justify="center" align="center">
          <Col sm={12} md={12} lg={9} xl={7}>
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FullBanner;
